/* eslint-disable react/prop-types */
import { UserIcon } from '@sketchnote/icons';
import * as React from 'react';
import { components as SelectComponents } from 'react-select';

export const AssigneMenu = (props) => {
  return (
    <>
      <SelectComponents.Menu {...props}>
        <div>{props.children}</div>
        <button
          onClick={props.selectProps.onAssignDuplicateClick}
          className="pt-16 pb-12 px-8 text-primary-500 text-sm border-t w-full text-left mt-8"
        >
          <span className="align-text-top">
            <UserIcon />
          </span>
          <span className="ml-8 font-medium">Assign duplicate task</span>
        </button>
      </SelectComponents.Menu>
    </>
  );
};
